import { AiAgentVideo } from '@/assets';
import { FC, memo } from 'react';

type Props = {
  size?: number;
};

const InnerAiAgentLoading: FC<Props> = ({ size = 500 }) => {
  return (
    <video
      width={size}
      height={size}
      autoPlay
      loop
      muted
      playsInline
      disablePictureInPicture
      src={AiAgentVideo}
    />
  );
};

InnerAiAgentLoading.displayName = 'InnerAiAgentLoading';

export const IconAILoading: FC<Props> = memo(InnerAiAgentLoading);
IconAILoading.displayName = 'IconAILoading';
